import React from "react";

//reactstrap
import { Button, FormGroup, Label } from "reactstrap";

//textarea
import TextareaAutosize from "react-textarea-autosize";

function TextareaAutosizeInput(props) {
    const { handleChange, nameState, handleSubmit, disabled } = props && props;
    return (
        <FormGroup>
            <Label className="font-weight-500">Text:</Label>
            <TextareaAutosize
                name="text"
                placeholder=""
                onChange={handleChange}
                className="w-100 form-control"
                maxRows="10"
                minRows={2}
                defaultValue={nameState?.Text || ""}
                autoFocus
            />
            <div className="text-right">
                <Button
                    color="primary"
                    className="btn btn-brand mt-3"
                    onClick={handleSubmit}
                    disabled={disabled}
                >
                    Submit
                </Button>
            </div>
        </FormGroup>
    );
}

export default TextareaAutosizeInput;